// import 'jquery-validation';
// import jQuery from './routes/jquery.min';

import Utils from '../../util/utils';
import intlTelInput from 'intl-tel-input';
const Inquiry = {
    _jForm: $('.jsInquiry'),
    _iti : null,
    // _jBookButton: $('#book__meeting'),
    
    init() {
        // this.initValidations();
        this.addEvents();
        
    },
    addEvents(){

        if ($('.jsInquiry').length > 0) {
            const input = document.querySelector('#phone');
            this._iti = intlTelInput(input, {
                // any initialisation options go here
                utilsScript: '/wp-content/themes/mint/node_modules/intl-tel-input/build/js/utils.js',
                initialCountry: 'sg',
                autoPlaceholder: 'aggressive',
                preventInvalidNumbers: true,
                separateDialCode: true,

            });

           
        }

    },
    // initValidations() {
    //     const me = this;
        
    //     $.validator.addMethod('intlTelNumber', function(value, element) {
    //         return this.optional(element) || me._iti.isValidNumber();
            
    //     }, 'Please enter a valid Phone Number');
        
    //     // console.log(this);
    //     if (this._jForm.length > 0) {
    //         var config = Utils.getValidationConfig({
    //             ignore: [],
    //             rules: {
    //                 inquiry_type:{
    //                     required: true,
    //                 },
    //                 terminal_inquiry:{
    //                     required: true,
    //                 },
    //                 travel_inquiry:{
    //                     required: true,
    //                 },
    //                 date: {
    //                     required: true,
    //                 },
    //                 time: {
    //                     required: true,
    //                 },
    //                 your_name: {
    //                     required: true,
    //                     minlength: 3,
    //                 },
    //                 phone: {
    //                     required: true,
    //                     intlTelNumber:true,
    //                     digits: true,
    //                 },
    //                 e_mails: {
    //                     required: true,
    //                     customemail: true,
    //                     // emailNotBanned: true,
    //                 },
    //                 inquiry_subject:{
    //                     required: true,
    //                 },
    //                 inq_msg: {
    //                     required: true,
    //                     // maxlenght: 500,
    //                 },
    //                 inq_desc: {
    //                     required: true,
    //                     // maxlenght: 500,
    //                 }, 
    //                 condition: {
    //                     required: true,
    //                 },                    
    //             },
    //             messages: {
    //                 inquiry_type: {
    //                     required: 'Please Select Any Option',
    //                 },
    //                 terminal_inquiry: {
    //                     required: 'Please Select Any Option',
    //                 },
    //                 travel_inquiry: {
    //                     required: 'Please Select Any Option',
    //                 },
    //                 date: {
    //                     required: 'Please Select Date',
    //                 },
    //                 time: {
    //                     required: 'Please enter Time',
    //                 },
    //                 your_name: {
    //                     required: 'Please provide your Name',
    //                     minlength: 'Please provide your complete Name',
    //                 },
    //                 phone: {
    //                     required: 'Please provide your Mobile number',
    //                     digits: 'Please enter only digits',
    //                 },
    //                 full_name: {
    //                     required: 'Please provide your Name',
    //                     minlength: 'Please provide your complete Name',
    //                 },
    //                 e_mails: {
    //                     required: 'Please provide your E-mail address',
    //                     customemail: 'Please provide a valid E-mail address',
    //                 },
    //                 inquiry_subject:{
    //                     required: 'Please enter your Inquiry Subject here',
    //                 },
    //                 inq_msg: {
    //                     required: 'Please enter your Message in detail ',
    //                     // maxlenght: 'please type 500 text',
    //                 },
    //                 inq_desc: {
    //                     required: 'Please enter Incident Description in detail ',
    //                 },
    //                 condition: {
    //                     required: 'You must agree with the Terms and Privacy Policy',
    //                 }, 
    //             },
                
    //             submitHandler: function() {
    //                 me.onFormSubmit();
    //             },
    //         });

    //         this._jForm.validate(config);
    //     }
    // },
    onFormSubmit() {
        if (this._jForm.valid()) {

            // $('.loader').show();
            var $form = this._jForm;
            var unindexed_array = $form.serializeArray();
            var indexed_array = {};
            jQuery.map(unindexed_array, function(n) { 
                indexed_array[n['name']] = n['value'];
            });

            var formData = {};
            formData = indexed_array;
            console.log(formData);
            // formData.form_type = 'plans_from';
           
            Utils.sendRequest({
                'url': '/wp-admin/admin-ajax.php',
                'data': {
                    'action': 'getInquiryForm',
                    'formData': formData,
                },
                'skipLoader': false,
                'onDone': $.proxy(this._onSuccess, this),
            });

        }

        return false;
    },

    _onSuccess(response) {
        this._jForm[0].reset();
        // $('.loader').hide();
        Utils.showLoader(true);
        Utils.notify({
            'message': response.message,
        });

    },

}
export default Inquiry;


// WEBPACK FOOTER //
// ./scripts/modules/forms/inquiry.js